import i18next from "i18next";
import { IFormsSpecificFormFormFieldOptionsFormFieldOptions } from "@cak-legacy/cms-iprox";
import { isNullable } from "@cak-legacy/core-utils";
import { RecordWithoutPrefix } from "../types";

type TranslationOption = RecordWithoutPrefix<
  IFormsSpecificFormFormFieldOptionsFormFieldOptions,
  "input" | "dropdownOption"
>;

type Option = { label: string; value: string };
type Map<T extends any> = (translation: TranslationOption) => T;

export function tOptions<T extends any>(t: typeof i18next.t, key: string, map: Map<T>): T[];
export function tOptions(t: typeof i18next.t, key: string): TranslationOption[];

export function tOptions<T extends Option>(t: typeof i18next.t, key: string, map?: Map<T>) {
  const translations = t(key, { returnObjects: true, defaultValue: [] }) as TranslationOption[];
  if (isNullable(map)) return translations;

  if (Array.isArray(translations)) return translations.map(map);
  return Object.entries(translations).map(([label, value]: [string, TranslationOption]) =>
    map({ label, ...value })
  );
}